module.exports = __webpack_public_path__ + "img/abstracts.8ca2cca5.svg";